import { useMutation } from 'react-query'
import { demoWorkflowDuplicatedEventRequest } from 'features/metrics/state/metricsSlice'
import { useAppDispatch } from 'app/state'
import { WorkflowDemo } from 'features/workflows/types'
import { createDemoWorkflow } from 'features/workflows/api/workflows'
import { addCreatingDemoWorkflowsId, removeCreatingDemoWorkflowsId } from '../../state/workflowsSlice'
import { useInvalidateWorkflowsList } from '../query'

export function useOpenDemoWorkflow() {
  const dispatch = useAppDispatch()
  const { invalidateWorkflowsList } = useInvalidateWorkflowsList()

  const createDemoWorkflowMutation = useMutation(createDemoWorkflow, {
    onMutate: (demo) => {
      dispatch(addCreatingDemoWorkflowsId(demo?.workflow?.id))
    },
    onError: (error, demo) => {
      dispatch(removeCreatingDemoWorkflowsId(demo?.workflow?.id))
    },
    onSuccess: (workflow, demo) => {
      invalidateWorkflowsList()
      if (workflow?.id) {
        window.open(`/workflows/${workflow.id}`, '_blank', 'noopener, noreferrer')
        dispatch(removeCreatingDemoWorkflowsId(demo?.workflow.id))
      }
    }
  })

  return (demo: WorkflowDemo) => {
    if (demo.workflow.id) {
      if (demo.exists) {
        window.open(`/workflows/${demo.workflow.id}`, '_blank', 'noopener, noreferrer')
      } else {
        createDemoWorkflowMutation.mutateAsync(demo)
        dispatch(demoWorkflowDuplicatedEventRequest({ item: demo.workflow.id }))
      }
    }
  }
}
